import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import SwitchSuccessorCommand from './switchSuccessorCommand';

/**
 * @class CommandFactory
 */
export default class CommandFactory {
    /**
     * Inititalizes the factory instance.
     *
     * @constructor
     * @param {SelectionCollection} selection Selection collection
     */
    constructor(selection) {
        this.selection = selection;
    }

    /**
     *
     * @param {AbstractItem} oldItem
     * @param {AbstractItem} newItem
     * @return {SwitchSuccessorCommand}
     */
    createSwitchSuccessorCommand(oldItem, newItem) {
        return new SwitchSuccessorCommand(oldItem.getParentItem().getItems(), this.selection, [{ oldItem, newItem }]);
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.Factory = CommandFactory;
